import { createSlice } from '@reduxjs/toolkit';
const slice = createSlice({
    name: 'access_requests',
    initialState: () => {
        return window.PRELOAD.access_requests != null
            ? window.PRELOAD.access_requests
            : { in: [], out: [] };
    },
    reducers: {
        updateAccessRequests: (state, action) => action.payload,
    },
});
export const { updateAccessRequests } = slice.actions;
export const accessRequestsReducer = slice.reducer;
